import { billing_v1 as billingV1 } from '@careerstart/wae-common/src/main/constants/exports-csvs/billing';
import { payroll_ext_v1 as payrollExtV1 } from '@careerstart/wae-common/src/main/constants/exports-csvs/payroll-external';
import { payroll_v3 as payrollV3 } from '@careerstart/wae-common/src/main/constants/payroll';

import FormBreakTime from '../../../main-deprecated/components/Form/FormBreakTime';
import FormPunchPicker from '../../../main-deprecated/components/Form/FormPunchPicker';
import {
  composeValidators,
  isGreaterThanOrEqual,
  isInteger,
  punchInExistIfPunchOutDoes,
  punchOutAfterPunchIn,
} from '../../components/Form/validations';

export const TIMEKEEPING_STATUSES = {
  APPROVED: 'approved',
  CONFLICT: 'conflict',
  PENDING: 'pending',
  DISPUTED: 'disputed',
  RESOLVED: 'resolved',
  FINALIZED: 'finalized',
  OVERTIME: 'overtime',
};

export const BULK_ACTION_TYPES = {
  APPROVE: 'Approve',
  RESOLVE: 'Resolve',
  FINALIZE: 'Finalize',
};

export const EXPORT_TYPES = {
  PAYROLL: 'payroll',
  CS_PAYROLL: 'csPayroll',
  BILLING: 'billing',
};

export const EXPORT_FILE_NAMES = {
  [EXPORT_TYPES.PAYROLL]: 'Payroll Export',
  [EXPORT_TYPES.CS_PAYROLL]: 'CareerStart Payroll Export',
  [EXPORT_TYPES.BILLING]: 'Billing Export',
};

export const EXPORT_API_PATH = {
  [EXPORT_TYPES.PAYROLL]: 'v3/payroll-data',
  [EXPORT_TYPES.CS_PAYROLL]: 'payroll/external-data',
  [EXPORT_TYPES.BILLING]: 'billing-data',
};
export const EXPORT_COLUMNS = {
  [EXPORT_TYPES.PAYROLL]: payrollV3,
  [EXPORT_TYPES.CS_PAYROLL]: payrollExtV1,
  [EXPORT_TYPES.BILLING]: billingV1,
};

export const TIMEKEEPING_TAGS = {
  DISPUTED: 'disputed',
  MISSING_PUNCH: 'missingPunch',
  LOOKS_GOOD: 'looksGood',
  SUSPICIOUS: 'suspicious',
};

export const WEEKLY_DAILY_OPTIONS = {
  daily: {
    label: 'timekeeping.filter.dailyView',
    value: 'daily',
  },
  weekly: {
    label: 'timekeeping.filter.weeklyView',
    value: 'weekly',
  },
};

export const TIMECARD_UPDATE_FORM_FIELDS = {
  punches: {
    ComponentType: FormPunchPicker,
    label: 'Punches',
    name: 'punches',
    validate: composeValidators(punchInExistIfPunchOutDoes, punchOutAfterPunchIn),
  },
  break: {
    ComponentType: FormBreakTime,
    label: 'Break (min)',
    name: 'breakDelta',
    validate: composeValidators(isInteger, isGreaterThanOrEqual(0)),
  },
};
